<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Son Kullanıcı Yönetimi</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>User ID</h4>
          <v-text-field
            maxlength="255"
            v-model="userId"
            type="number"
            counter="255"
            :rules="userIdRule"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-btn
            color="#4d48f9"
            style="margin-top: 40px; color: white; width: 90px;"
            @click="getUserData()"
            :disabled="isButtonDisabled"
          >
            Ara
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    valid: true,
    userIdRule: [
      (v) => !!v || 'User ID alanı zorunludur.',
      (v) => /^\d+$/.test(v) || 'Sadece sayı girilmelidir.',
    ],
    errorList: [],
    userId: '',
    dialog: false,
    isButtonDisabled: true,
  }),
  methods: {
    ...mapActions(['getUser', 'checkUserValid']),
    routeEndUserManagementDetail() {
      this.$router.push(`/dashboard/endUserManagement/${this.userId}`)
    },
    getUserData() {
      this.checkUserValid(this.userId)
        .then((response) => {
          console.log(response)
          if (response.processStatus == 'Success') {
            this.routeEndUserManagementDetail()
          }
        })
        .catch((err) => {
          if (err.response.data.processStatus == 'Error') {
            if (err.response.data.friendlyMessage.message == 'user_not_found') {
              alert('Bu user ID ile sisteme kayıtlı kullanıcı bulunmamaktadır.')
            }
          }
        })
    },
  },
  watch: {
    userId: function () {
      if (this.userId.toString().length >= 1) {
        this.isButtonDisabled = false
      } else {
        this.isButtonDisabled = true
      }
    },
  },
}
</script>
